"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Separator = exports.Root = exports.AdditionalItem = exports.AccountBalanceTitle = exports.AccountBalanceItem = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        padding: theme.spacing(3),
        marginTop: theme.spacing(3),
        background: theme.palette.background.paper,
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(3, 6),
            borderRadius: theme.spacing(2)
        }
    };
});
const AdditionalItem = exports.AdditionalItem = (0, _mui.styled)('div')({
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 'bold',
    cursor: 'pointer',
    alignItems: 'center'
});
const AccountBalanceTitle = exports.AccountBalanceTitle = (0, _mui.styled)('div')({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
});
const AccountBalanceItem = exports.AccountBalanceItem = (0, _mui.styled)(_mui.Typography)({
    fontWeight: 'bold',
    '&:after': {
        content: '", "',
        whiteSpace: 'pre'
    },
    '&:last-child:after': {
        content: '""'
    }
});
const Separator = exports.Separator = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        height: 1,
        width: '100%',
        backgroundColor: theme.palette.grey[200],
        margin: theme.spacing(2, 0)
    };
});
